import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, Section } from "./Field";
import { SOCIALS } from "@/lib/card";

export const LinksTab = ({ card, update }) => {
  const [draft, setDraft] = useState({ label: "", url: "" });
  const setSocial = (k) => (v) => update({ socials: { ...card.socials, [k]: v } });
  const add = () => {
    if (!draft.label.trim() || !draft.url.trim()) return;
    update({ links: [...card.links, { id: crypto.randomUUID(), ...draft }] });
    setDraft({ label: "", url: "" });
  };
  const remove = (id) => update({ links: card.links.filter((l) => l.id !== id) });

  return (
    <div className="space-y-6">
      <Section title="Social" hint="Incolla il link completo al tuo profilo.">
        {SOCIALS.map((s) => (
          <Field key={s.key} label={s.label} value={card.socials[s.key]} onChange={setSocial(s.key)} testId={`input-social-${s.key}`} placeholder={`${s.key}.com/...`} />
        ))}
      </Section>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h3 className="text-lg font-semibold">Link Personalizzati</h3>
        <p className="mt-1 text-sm text-slate-500">Catalogo PDF, prenotazioni, recensioni, menu...</p>
        <div className="mt-6 space-y-2">
          {card.links.map((l) => (
            <div key={l.id} data-testid={`link-item-${l.id}`} className="flex items-center gap-3 rounded-xl border border-slate-200 px-4 py-3">
              <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold">{l.label}</p><p className="truncate text-xs text-slate-500">{l.url}</p></div>
              <Button variant="ghost" size="icon" onClick={() => remove(l.id)} data-testid={`link-remove-${l.id}`}><Trash2 size={16} /></Button>
            </div>
          ))}
        </div>
        <div className="mt-4 flex flex-col gap-2 sm:flex-row">
          <Input placeholder="Etichetta" value={draft.label} onChange={(e) => setDraft({ ...draft, label: e.target.value })} data-testid="input-link-label" />
          <Input placeholder="https://..." value={draft.url} onChange={(e) => setDraft({ ...draft, url: e.target.value })} data-testid="input-link-url" />
          <Button onClick={add} className="bg-slate-900" data-testid="button-add-link"><Plus size={16} className="mr-1" /> Aggiungi</Button>
        </div>
      </div>
    </div>
  );
};
